import React from "react";
import "./App.css";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import ExplorationMode from "./Components/ExplorationMode/ExplorationMode";
import StoryMode from "./Components/StoryMode/StoryMode";
import HomePage from "./Components/HomePage/HomePage";
import CreditPage from "./Components/Credit/CreditPage";

function App() {

	return (
		<div className="App">
			<Router>
				<Routes>
					<Route exact path="/" element={<HomePage />} />
					<Route path="/libre" element={<ExplorationMode />} />
					<Route path="/narratif" element={<StoryMode />} />
					<Route path="/credit" element={<CreditPage />} />
				</Routes>
			</Router>
		</div>
	);
}

export default App;
